var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgContactSupportFilled = function SvgContactSupportFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M3.333 5.778a2.445 2.445 0 0 1 2.445-2.445h12.444a2.445 2.445 0 0 1 2.445 2.445V20a.667.667 0 0 1-.98.588L16.5 18.89H5.778a2.445 2.445 0 0 1-2.445-2.445V5.778Zm5.99 3.007c0-1.48 1.2-2.674 2.677-2.674a2.676 2.676 0 0 1 2.676 2.676c0 1.165-.76 1.779-1.285 2.131v.001c-.44.294-.642.524-.642.917v.24a.75.75 0 0 1-1.5 0v-.24c0-1.181.769-1.803 1.306-2.163.216-.145.369-.272.47-.41a.75.75 0 0 0 .151-.476 1.176 1.176 0 0 0-2.353-.002.75.75 0 0 1-1.5 0Zm1.752 6.184a.923.923 0 1 1 1.85-.01.923.923 0 0 1-1.85.01Zm.348 0-.348.004v-.008h.348v.004Zm1.152 0 .348.004v-.008h-.348v-.008m0 .008v.004-.004Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContactSupportFilled);
export default ForwardRef;